<template>
    <form class="d-flex flex-column gap-2 gap-column-3 width-max-700 mx-auto">
        <FormValidator form-group label-class="pb-0" :validator="$v.form.url" v-slot="slotProps" :label="$t('url.label')">
            <b-form-input v-model="form.url" :placeholder="$t('url.placeholder')" :state="slotProps.state" :disabled="loading" />
        </FormValidator>
        <FormValidator form-group label-class="pb-0" :validator="$v.form.name" v-slot="slotProps" :label="$t('name.label')">
            <b-form-input v-model="form.name" :placeholder="$t('name.placeholder')" :state="slotProps.state" :disabled="loading" />
        </FormValidator>
        <FormValidator form-group label-class="pb-0" :validator="$v.form.categories" v-slot="slotProps" :label="$t('categories.label')">
            <Multiselect
                :placeholder="$t('categories.placeholder')"
                :fetch-options-function="fetchCategories"
                :close-on-select="false"
                :searchable="true"
                :multiple="true"
                track-by="id"
                label="name"
                select-label=""
                :disabled="loading"
                :state="slotProps.state"
                @inputTrackBy="form.categories = $event"
            />
        </FormValidator>
        <FormValidator form-group label-class="pb-0" :validator="$v.form.type" v-slot="slotProps" :label="$t('type.label')">
            <Multiselect
                :placeholder="$t('categories.placeholder')"
                :fetch-options-function="fetchSpaceTypes"
                :asynchronous="false"
                track-by="value"
                label="label"
                :disabled="loading"
                :state="slotProps.state"
                @inputTrackBy="form.type = $event"
            />
        </FormValidator>
        <ButtonIcon class="ml-auto wide" :disabled="loading" :loading="loading" hide-label-while-loading @click="formSubmit">{{ $t('button.submit') }}</ButtonIcon>
    </form>
</template>



<script>
    import { required, url, minLength } from 'vuelidate/lib/validators';
    import { uniqueUrl } from '@/utils/validators';
    import cloneDeep from 'lodash/cloneDeep';
    import formBackendValidationMixin from '@/mixins/formBackendValidationMixin';
    import FormValidator from '@/components/common/FormValidator.vue';
    import Multiselect from '@/components/common/Multiselect.vue';

    const EXCLUDED_URLS = ['facebook.com', 'instagram.com', 'tiktok.com', 'youtube.com', 'google.pl', 'google.com', 'allegro.pl', 'vinted.pl'];

    const FORM_DEFAULT_DATA = Object.freeze({
        name: '',
        url: '',
        categories: [],
        type: null,
        description: '...',
    });

    export default {
        name: 'FormAddWebsite',
        mixins: [formBackendValidationMixin],
        components: {
            FormValidator,
            Multiselect,
        },
        data() {
            return {
                form: cloneDeep(FORM_DEFAULT_DATA),
                requestCategoryCategories: this.$req('category/categories'),
                requestSpaceTypes: this.$req('space/spaceTypes'),
                requestSpace: this.$req('space/space'),
            };
        },
        computed: {
            formValidations() {
                return {
                    form: {
                        name: { required },
                        url: {
                            required,
                            url,
                            unique: value => uniqueUrl(value, this.spacesUrlList),
                            tooGeneralUrl: value => uniqueUrl(value, EXCLUDED_URLS),
                        },
                        categories: { required, minLength: minLength(1) },
                        type: { required },
                    },
                };
            },
            user() {
                return this.$store.getters['auth/getUser'];
            },
            spacesUrlList() {
                return Object.values(this.$store.state.space.spaces).map(item => item.url);
            },
            loading() {
                return this.requestSpace.getLoading();
            },
        },
        methods: {
            fetchCategories() {
                return this.requestCategoryCategories.get();
            },
            fetchSpaceTypes() {
                return this.requestSpaceTypes.get().then(data => data.items);
            },
            formSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                this.requestSpace
                    .post(this.user.id, this.form)
                    .then(() => this.$emit('next'))
                    .catch(this.handleBackendValidations);
            },
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "url": {
        "label": "Adres URL",
        "placeholder": "https://"
    },
    "name": {
        "label": "Nazwa",
        "placeholder": "Podaj nazwę swojej strony, bloga lub profilu social media"
    },
    "categories": {
        "label": "Kategoria",
        "placeholder": "Wybierz"
    },
    "type": {
        "label": "Typ",
        "placeholder": "Wybierz"
    },
    "button": {
        "submit": "Dalej"
    },
    "msgSuccess": "Strona „{name}” została pomyślnie utworzona."
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "url": {
        "label": "URL address",
        "placeholder": "https://"
    },
    "name": {
        "label": "Name",
        "placeholder": "Enter your website, blog or social media profile name"
    },
    "categories": {
        "label": "Category",
        "placeholder": "Select"
    },
    "type": {
        "label": "Type",
        "placeholder": "Select"
    },
    "button": {
        "submit": "Next"
    },
    "msgSuccess": "The „{name}” page was successfully created."
}
</i18n>
